import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import useWarehouseIdForZipCode from 'hooks/useWarehouseIdForZipCode';
import { DEFAULT_WAREHOUSE_ID } from 'commons/constants';
import useCloudfrontLocationAPI from './useCloudFrontLocationAPI';
const EMPTY_LOCATION = {};

// This hook is used to get the user's location using the CloudFront API.
// The values are returned in a standard format to allow the
// useRefreshUserLocation hook to return the best available location for the
// user.
const useLocationFromCloudFront = t0 => {
  const $ = _c(13);
  const {
    skip: t1
  } = t0;
  const skip = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== skip) {
    t2 = {
      skip
    };
    $[0] = skip;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    error: locationFromCloudFrontError,
    isLoading: isLocationLoading,
    location: locationFromCloudFront
  } = useCloudfrontLocationAPI(t2);
  const countryNameFromCloudFront = locationFromCloudFront?.country_name;
  const isInternationalUser = !skip && !!countryNameFromCloudFront && countryNameFromCloudFront !== "United States";
  const enableWarehouseIdForCloudfrontLocation = !skip && !!locationFromCloudFront?.postal_code && !isInternationalUser;
  const {
    error: warehouseIdForCloudfrontLocationError,
    loading: isWarehouseIdLoading,
    warehouseId: warehouseIdForCloudFrontLocation
  } = useWarehouseIdForZipCode(enableWarehouseIdForCloudfrontLocation ? locationFromCloudFront?.postal_code : undefined);
  const shouldUseLocation = !skip && countryNameFromCloudFront && !locationFromCloudFrontError && !warehouseIdForCloudfrontLocationError;
  let t3;
  bb0: {
    if (!shouldUseLocation) {
      t3 = undefined;
      break bb0;
    }
    if (isInternationalUser) {
      t3 = EMPTY_LOCATION;
      break bb0;
    }
    const {
      city: cityName,
      country_name: country,
      country_region_name: state,
      country_region: stateShortName,
      postal_code
    } = locationFromCloudFront;
    const t4 = cityName || state;
    const t5 = `${postal_code}`;
    let t6;
    if ($[2] !== country || $[3] !== state || $[4] !== stateShortName || $[5] !== t4 || $[6] !== t5) {
      t6 = {
        city: t4,
        country,
        state,
        stateShortName,
        zip: t5
      };
      $[2] = country;
      $[3] = state;
      $[4] = stateShortName;
      $[5] = t4;
      $[6] = t5;
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    t3 = t6;
  }
  const location = t3;
  let t4;
  bb1: {
    if (!shouldUseLocation) {
      t4 = undefined;
      break bb1;
    }
    if (isInternationalUser) {
      t4 = DEFAULT_WAREHOUSE_ID;
      break bb1;
    }
    t4 = warehouseIdForCloudFrontLocation;
  }
  const warehouseId = t4;
  const t5 = !skip ? !locationFromCloudFrontError && !warehouseIdForCloudfrontLocationError && (isLocationLoading || isWarehouseIdLoading) : false;
  let t6;
  if ($[8] !== location || $[9] !== shouldUseLocation || $[10] !== t5 || $[11] !== warehouseId) {
    t6 = {
      isLoading: t5,
      location,
      shouldUseLocation,
      warehouseId
    };
    $[8] = location;
    $[9] = shouldUseLocation;
    $[10] = t5;
    $[11] = warehouseId;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default useLocationFromCloudFront;